import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import config from './../config'

Vue.use(Vuex)

const storeBase = {

  state: {
    top_products: [],
    top_categories: []
  },
  mutations: {
    top_products (state, top_products) {
      state.top_products = top_products
    },
    top_categories (state, top_categories) {
      state.top_categories = top_categories
    }
  },
  actions: {
    top_products ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/articles/top', {
          baseURL: config.api.url,
          params: {
            limit: 16
          }
        }).then(response => {
          commit('top_products', response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })

      })
    },
    top_categories ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/categories/top', {
          baseURL: config.api.url,
          params: {
            limit: 16
          }
        }).then(response => {
          commit('top_categories', response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })

      })
    }
  }

}

const store = new Vuex.Store(storeBase)

export default store



// WEBPACK FOOTER //
// ./client/store/index.js